var map = {
	"./alarm.svg": "mMjV",
	"./apply.svg": "gyG/",
	"./ashbin.svg": "ThcP",
	"./camera.svg": "2vhn",
	"./collect.svg": "roky",
	"./collect1.svg": "t0re",
	"./course.svg": "4t1d",
	"./course1.svg": "4mgi",
	"./grade.svg": "v7/U",
	"./home.svg": "U9Ws",
	"./home1.svg": "ldqe",
	"./logout.svg": "KvOj",
	"./money.svg": "ig9B",
	"./net.svg": "oAFF",
	"./notice.svg": "MqGM",
	"./number.svg": "tyP3",
	"./order.svg": "gYtG",
	"./pageTo.svg": "Ze2A",
	"./person.svg": "iMuv",
	"./person1.svg": "OkjK",
	"./plan.svg": "0Ex+",
	"./plant.svg": "3X3C",
	"./player.svg": "rKt9",
	"./record.svg": "1XyD",
	"./record1.svg": "lGHd",
	"./relog.svg": "izCD",
	"./report.svg": "2nwU",
	"./right.svg": "9iyg",
	"./submit.svg": "6yke",
	"./submit1.svg": "R9zu",
	"./test.svg": "fjDP",
	"./uncollect.svg": "r6vt",
	"./warn.svg": "a5SC",
	"./warning.svg": "TcIt",
	"./yzs.svg": "buxe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 40